module.exports = __webpack_public_path__ + "static/16-387ac7b83ebfa1a09283bc5610b4508c.jpg";